import {Button, ButtonProps} from '@mantine/core'
import {createLink, type LinkComponent} from '@tanstack/react-router'
import React from 'react'

const MantineButton = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    return <Button ref={ref} {...props} />
})

const CreatedLink = createLink(MantineButton)

/**
 * A component that wraps Mantine's Button component with the behavior of a Link
 * from TanStack Router.
 * @param props - The combined props of the Button and Link components.
 */
export const LinkButton: LinkComponent<typeof MantineButton> = (props) => {
    return <CreatedLink preload="intent" {...props} />
}

export default LinkButton
